(() => {
  const SELECTOR = "[data-pfi]";

  const toggle = (container) => {
    const button = container.querySelector("[data-pfi-toggle]");
    const isOpen = container.classList.toggle("is-open");
    if (button) button.setAttribute("aria-expanded", String(isOpen));
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((container) => {
      const button = container.querySelector("[data-pfi-toggle]");
      if (!button || button.dataset.pfiBound) return;
      button.dataset.pfiBound = "true";
      button.addEventListener("click", () => toggle(container));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();